import React from "react"


import DashBoard from "./Components/DashBoard/DashBoard";





function App() {
  return (
 <div>
<DashBoard/>

 </div>
  );
}

export default App;
